import React from 'react';
import { useSelector } from 'react-redux';
import LoadingOverlay from 'components/LoadingOverlay';
import StepContainer from '../StepContainer';
import { useStepNavigationContext } from '../../context';
import { ErrorAlert, IntercomLink } from './styled';

const StepView = ({ children }: { children: React.ReactNode }) => {
  const { stepNumber, stepsLength, changeStep } = useStepNavigationContext();

  const { error, isLoading } = useSelector(
    (state: any) => state.nomadInsurance.application
  );

  return (
    <StepContainer
      stepNumber={stepNumber + 1}
      totalSteps={stepsLength}
      onStepChange={(stepDelta: number) => changeStep(stepDelta)}
    >
      <LoadingOverlay isLoading={isLoading} variant="light" roundedCorners />
      {error && !isLoading ? (
        <ErrorAlert label={error?.title || 'Something went wrong'} variant="danger">
          {error?.message || (
            <>
              Something went wrong. Please contact{' '}
              <IntercomLink
                // @ts-ignore
                onClick={() => window.Intercom('showNewMessage')}
              >
                customer service
              </IntercomLink>
              .
            </>
          )}
        </ErrorAlert>
      ) : (
        children
      )}
    </StepContainer>
  );
};

export default StepView;
